export enum itemTypes {
    group = "GROUP",
    template = "TEMPLATE"
}

export type ItemType = "GROUP" | "TEMPLATE"

export enum accessTypes {
    admin = "ADMIN",
    user = "USER"
}

export type AccessType = "ADMIN" | "USER"

export enum userTypes {
    person = "PERSON",
    group = "GROUP",
    all = "ALL"
}

export type UserType = "PERSON" | "GROUP" | "ALL" | ""

export interface IRole {
    roleId?: number,
    itemType: ItemType,
    itemId: number,
    accessType: AccessType,
    userType: UserType,
    userId: string,
    userName: string,
    userNameEn: string
}

export interface IRoleService {
    loadRoleList: (itemType: ItemType,
                   itemId: number,
                   accessType: AccessType,
                   userType: UserType,
                   userId: string) => Promise<IRole[]>
    deleteRole: (itemType: ItemType,
                  itemId: number,
                  roleId: number) => Promise<string>
    addRole: (itemType: ItemType,
              accessType: AccessType,
              userType: UserType,
              itemId: number,
              userId: string,
              userName?: string,
              userNameEn?: string
    ) => Promise<number>;
    downloadRoleMatrix: () => Promise<Blob>;
    downloadRoleTree: () => Promise<Blob>;
    uploadRoleMatrix: (fileName: string, file: File) => Promise<string>;
    uploadRoleTree: (fileName: string, file: File) => Promise<string>;
}
